import Marquee from "react-fast-marquee";

const items = [
    "Government & Public Sector",
    "Banking & Financial Services",
    "Corporate Enterprises",
    "Property Managers",
    "SMEs",
    "NGOs",
    "Event Organizers",
    "Ministries",
    "Financial Institutions",
    "Regulators",
];

export default function TrustedMarquee() {
    return (
        <section data-testid="trusted-marquee" className="editorial-marquee py-10">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-4">
                <div className="text-slate-500 text-[11px] font-mono tracking-[0.25em] uppercase">Designed For</div>
            </div>
            <Marquee gradient={false} speed={35} pauseOnHover>
                <div className="marquee-track font-serif text-4xl md:text-5xl text-slate-900">
                    {items.map((it, i) => (
                        <span key={i} className="flex items-center gap-16 tracking-tight">
                            <span>{it}</span>
                            <span className="w-2 h-2 rounded-full bg-[#E8B923]" />
                        </span>
                    ))}
                </div>
            </Marquee>
        </section>
    );
}
